import React, { useEffect, useMemo, useState } from "react";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { format } from "date-fns";
import { Card, Form, Modal } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import Button from "@mui/material/Button";
import { Clear, Refresh, Search } from "@material-ui/icons";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DataTable from "react-data-table-component";
import ReactiveButton from "reactive-button";
import { useDispatch, useSelector } from "react-redux";
import { setSearchDetails, setSearchDetails2 } from "src/reducer/search_filter/searchSlice";
import { getExceptionReprtData, getNonRevarcData } from "src/context/actions/dashboard";
import { _static_messages } from "src/components/common/Messages";
import createNotification from "src/components/common/NotificationContainer";
import { PAYMENT_HTML_VIEW } from "src/constants/routeName";
import { exportFile } from "src/helpers/utils";
import Flatpickr from "react-flatpickr";
import { algo } from "crypto-js";
import { decryptResponse } from "src/components/common/EncryptDecrypt";
import { reactLocalStorage } from "reactjs-localstorage";
import ExceptionReportModal from "src/components/common/PopupModal/ExceptionReportModal";
import Clientdropdown from "src/components/common/Facility-ClientDropdown/Clientdropdown";
import Facilitydropdown from "src/components/common/Facility-ClientDropdown/Facilitydropdown";
import { useClient, useFacility } from "src/views/components/utils/dropdownFunctions";
import { useSortableBoard } from "../global_search/hooks/useSortableBoard";
import DragToSortDropdown from '../global_search/utils/sortableHeadings'
import { downloadSnippingimageFileApi1, generatedFileDownload } from "src/context/actions/global_search";
import { HiChevronDown, HiOutlineDocumentText } from 'react-icons/hi'
import color from "src/constants/theme/colors";
import dayjs from "dayjs";
import ExportWithReason from "src/components/common/ExportWithReason";
import Proxy from "src/components/common/Redirect/Proxy";
import TableColumnResizer from "src/components/TableColumnResizer";

const NonRevarcDashboard = ({ setHeading }) => {
 const clientDropdownData = useClient();
 const facilityDropdowndata= useFacility();

  const { DateTime } = require("luxon");
  const user = decryptResponse(reactLocalStorage.getObject("user", {}));

  const dispatch = useDispatch();
  const state = useSelector((state) => state?.filter);
  let [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [exceptionLoader, setExceptionLoader] = useState(null);
  const [toggleReportPopup, setToggleReportPopup] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [status, setStatus] = useState(null);
  const [searchedStatus, setSearchedStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const flatpickrUploadRef = React.useRef(null);
  const filesubmiteRef = React.useRef(null);

  const [popup, setPopup] = useState({
    view: false,
    reason: "",
    data: "",
    type: "",
  });

  const nf = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const [search, setSearch] = useState({
    date: [dayjs().subtract(1, 'day').toDate(), dayjs().toDate()],
    is_exclude: false,
    is_file_level: reactLocalStorage.get("is_file_level")||0,
    client_name: clientDropdownData,
    facility_name: facilityDropdowndata,
    lockbox_no: "",
    lockbox_file_name: "",
    errorField: {},
    sort_order: "",
    sort_key: "",
    file_name: "",
    file_submitted_date:"",
  });
  const [searchedKeys, setSearchedKeys] = useState({
    date: [dayjs().subtract(1, 'day').toDate(), dayjs().toDate()],
    is_exclude: false,
    is_file_level: reactLocalStorage.get("is_file_level")||0,
    client_name: clientDropdownData,
    facility_name: facilityDropdowndata,
    lockbox_no: "",
    lockbox_file_name: "",
    errorField: {},
    sort_order: "",
    sort_key: "",
    file_name: "",
    file_submitted_date:"",
  });

  ///////////////////////////////////////datatable functions ////////////////////////////////////

  const [pageno, setPageno] = useState(1);
  const [limit, setLimit] = useState(25);
  const [update, setUpdate] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [colorRow, setColorRow] = useState({});

  useEffect(() => {
    setHeading("File Monitoring");
  }, []);
  useEffect(() => {
    getFileMonitoringApi({ page: pageno, pageSize: limit });
  }, [update]);

  const getFileMonitoringApi = (query) => {
    setLoading(true);

    getNonRevarcData({ query: query, search: searchedKeys })((response) => {
      if (response.data?.status_code === 200) {
        setData(response?.data);
        setTotalRows(response?.data?.data?.count);
        setLoading(false);
      } else {
        createNotification("error", _static_messages.DEFAULT);
        setLoading(false);
      }
    });
  };
  const [datatable, setDatatable] = useState(true);
  const convertUTCtoLocalTime = (date) => {
    // Parse the provided date and time string as UTC
    let convertedDate = "";
    if (date) {
      const providedDateTime = DateTime.fromFormat(date, "yyyy-MM-dd HH:mm:ss", { zone: "utc" });
      // Convert the given time to system's local time
      const localTime = providedDateTime.setZone("local");
      // Format the local time as desired
      convertedDate = localTime.toFormat("MM-dd-yyyy hh:mm:ss a");
    }
    return convertedDate;
  };
  const downloadSnippetImageFile = (row) => {
    setLoading(true)
    let props = {
        file_path: row?.generated_output_file_name,
        lock_box: row?.lockbox_id,
        is_file_level: searchedKeys?.is_file_level,
    }
    generatedFileDownload(props)(response => {
        if (response.data?.status_code === 201) {
            setLoading(false)
            const OgUrl = response?.data?.data;
            const fileName = OgUrl.split("/").pop();
            let alink = document.createElement("a");
            alink.href = OgUrl;
            alink.download = fileName;
            alink.target = "_blank";
            alink.click();
        } else {
            createNotification("error", "File not found");
            setLoading(false);
        }
    });
};
  const [columnWidths, setColumnWidths] = useState({
    partner_name: 200,
    client_name: 150,
    facility_name: 150,
    lockbox_name: 200,
    deposit_date: 120,
    lockbox_file_name: 200,
    lockbox_file_new: 200,
    no_of_files: 80,
    no_of_jobs: 150,
    inprogress_files: 120,
    completed_files: 120,
    exception_files: 120,
    arrival_time: 180,
    expected_tat_annotation: 160,
    output_send_date: 180,
    output_generated_time: 150,
    action: 100,

  });

 const handleColumnResize = (columnId) => (e, { size }) => {
        setColumnWidths(prev => ({
            ...prev,
            [columnId]: size.width
        }));
    };
  const columns = useMemo(
    () => [
      {
        id: "partner_name",
        name: <>
          Partner Name
          <TableColumnResizer
            width={columnWidths.partner_name}
            // height={30} // Header height
            onResize={handleColumnResize('partner_name')}
          />
        </>,
        selector: (row) => row?.partner_name,
        cell: (row) => (
          <Tooltip title={row?.partner_name} disableInteractive>
            <div className="text-truncate" style={{ maxWidth: "250px" }} onClick={() => handleRowClick(row)}>
              <span> {row?.partner_name}</span>
            </div>
          </Tooltip>
        ),
        omit: !user?.is_superuser,
        width: `${columnWidths.partner_name}px`,
        sortable: true,
      },
      {
        id: "client_name",
        name: <>
          Client Name
          <TableColumnResizer
            width={columnWidths.client_name}
            // height={30} // Header height
            onResize={handleColumnResize('client_name')}
          />
        </>,
        selector: (row) => row?.client_name,
        cell: (row) => (
          <Tooltip title={row?.client_name} disableInteractive>
            <div className="text-truncate" onClick={() => handleRowClick(row)}>
              {row?.client_name}
            </div>
          </Tooltip>
        ),
        width: `${columnWidths.client_name}px`,
        sortable: true,
      },
      {
        id: "facility_name",
        name: <>
          Facility Name
          <TableColumnResizer
            width={columnWidths.facility_name}
            // height={30} // Header height
            onResize={handleColumnResize('facility_name')}
          />
        </>,
        selector: (row) => row?.facility_name,
        cell: (row) => (
          <Tooltip title={row?.facility_name} disableInteractive>
            <div className="text-truncate" onClick={() => handleRowClick(row)}>
              {row?.facility_name}
            </div>
          </Tooltip>
        ),
        width: `${columnWidths.facility_name}px`,
        sortable: true,
      },
      {
        id: "lockbox_name",
        name: <>
          Lockbox Name
          <TableColumnResizer
            width={columnWidths.lockbox_name}
            // height={30} // Header height
            onResize={handleColumnResize('lockbox_name')}
          />
        </>,
        selector: (row) => row?.lockbox_name,
        cell: (row) => (
          <Tooltip title={row?.lockbox_name} disableInteractive>
            <div className="text-truncate" style={{ maxWidth: "250px" }} onClick={() => handleRowClick(row)}>
              <span> {row?.lockbox_name}</span>
            </div>
          </Tooltip>
        ),
        width: `${columnWidths.lockbox_name}px`,
        sortable: true,
      },
      {
        id: "deposit_date",
        name: <>
          Deposit Date
          <TableColumnResizer
            width={columnWidths.deposit_date}
            // height={30} // Header height
            onResize={handleColumnResize('deposit_date')}
          />
        </>,
        selector: (row) => row?.deposit_date,
        cell: (row) => (row.deposit_date ? <span onClick={() => handleRowClick(row)}>{row.deposit_date}</span> : ""),
        width: `${columnWidths.deposit_date}px`,
        sortable: true,
      },
      {
        id: "lockbox_file_name",
        name: <>
         <span>{searchedKeys?.is_file_level==1?"File Name":"Lockbox File Name"}</span> 
          <TableColumnResizer
            width={columnWidths.lockbox_file_name}
            // height={30} // Header height
            onResize={handleColumnResize('lockbox_file_name')}
          />
        </>,
        selector: (row) => row?.lockbox_file_name,
        cell: (row) => (
          <Tooltip title={row?.lockbox_file_name} disableInteractive>
            <div className="text-truncate" onClick={() => handleRowClick(row)}>
              {row?.lockbox_file_name}
            </div>
          </Tooltip>
        ),
        width: `${columnWidths.lockbox_file_name}px`,
        sortable: true,
      },
      ...(searchedKeys?.is_file_level ? [{
        id: "lockbox_file_new",
        name: <>
          <sapn className="me-4"> Lockbox File Name</sapn>
          <TableColumnResizer
            width={columnWidths.lockbox_file_new}
            // height={30} // Header height
            onResize={handleColumnResize('lockbox_file_new')}
          />
        </>,
        selector: (row) => row?.lockbox_file,
        cell: (row) => (
          <Tooltip title={row?.lockbox_file} disableInteractive>
            <div
              className="text-truncate"
              style={{ maxWidth: "250px" }}
              onClick={() => handleRowClick(row)}
            >
              <span>{row?.lockbox_file}</span>
            </div>
          </Tooltip>
        ),
        width: `${columnWidths.lockbox_file_new}px`,
        sortable: true,
      }] : []),
      {
        id: "no_of_files",
        name: <>
          <span className="me-4"># Files</span>
          <TableColumnResizer
            width={columnWidths.no_of_files}
            // height={30} // Header height
            onResize={handleColumnResize('no_of_files')}
          />
        </>,
        cell: (row) => (
          <span style={{ textAlign: "right", marginRight: "10px" }} onClick={() => handleRowClick(row)}>
            {row.no_of_files}
          </span>
        ),
        right: true,
        omit: searchedKeys?.is_file_level == 1,
        width: `${columnWidths.no_of_files}px`,
        sortable: true,
      },
      {
        id: "no_of_jobs",
        name: <>
          <sapn className="me-4"> # Jobs</sapn>
          <TableColumnResizer
            width={columnWidths.no_of_jobs}
            // height={30} // Header height
            onResize={handleColumnResize('no_of_jobs')}
          />
        </>,
        cell: (row) => (
          <span style={{ textAlign: "right", marginRight: "10px" }} onClick={() => handleRowClick(row)}>
            {row.no_of_jobs}
          </span>
        ),
        right: true,
        width: `${columnWidths.no_of_jobs}px`,
        sortable: true,
      },
      {
        id: "inprogress_files",
        name: <>
          <span className="me-4"># Pending</span>
          <TableColumnResizer
            width={columnWidths.inprogress_files}
            // height={30} // Header height
            onResize={handleColumnResize('inprogress_files')}
          />
        </>,
        cell: (row) => (
          <span style={{ textAlign: "right", marginRight: "10px" }} onClick={() => handleRowClick(row)}>
            {row.inprogress_files}
          </span>
        ),
        right: true,
        width: `${columnWidths.inprogress_files}px`,
        sortable: true,
      },
      {
        id: "completed_files",
        name: <>
          <span className="me-4"> # Completed </span>
          <TableColumnResizer
            width={columnWidths.completed_files}
            // height={30} // Header height
            onResize={handleColumnResize('completed_files')}
          />
        </>,
        cell: (row) => (
          <span style={{ textAlign: "right", marginRight: "10px" }} onClick={() => handleRowClick(row)}>
            {row.completed_files}
          </span>
        ),
        right: true,
        width: `${columnWidths.completed_files}px`,
        sortable: true,
      },
      {
        id: "exception_files",
        name: <>
          <span className="me-4"># Exception Jobs</span>
          <TableColumnResizer
            width={columnWidths.exception_files}
            // height={30} // Header height
            onResize={handleColumnResize('exception_files')}
          />
        </>,
        cell: (row) => (
          <span style={{ textAlign: "right", marginRight: "10px" }} onClick={() => handleRowClick(row, "exception_files")}>
            {exceptionLoader == row?.select_id ? (
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            ) : (
              row.exception_files
            )}
          </span>
        ),
        right: true,
        width: `${columnWidths.exception_files}px`,
        sortable: true,
      },
      {
        id: "arrival_time", //because of export 
        name: <>
          Lockbox Arrival Time
          <TableColumnResizer
            width={columnWidths.arrival_time}
            // height={30} // Header height
            onResize={handleColumnResize('arrival_time')}
          />
        </>,
        selector: (row) => row?.lockbox_arrival_time,
        cell: (row) => (

          row.lockbox_arrival_time ? row.lockbox_arrival_time : ''
        ),
        width: `${columnWidths.arrival_time}px`,
        sortable: true,
      },
      {
        id: "expected_tat_annotation",
        name: <>
          Expected TAT
          <TableColumnResizer
            width={columnWidths.expected_tat_annotation}
            // height={30} // Header height
            onResize={handleColumnResize('expected_tat_annotation')}
          />
        </>,
        selector: (row) => row?.expected_tat,
        cell: (row) => (

          row.expected_tat ? row.expected_tat : ''
        ),
        width: `${columnWidths.expected_tat_annotation}px`,
        sortable: true,
      },
      {
        id: "output_send_date", //for the export  --branch 1041
        name: <>
          Delivery Date&Time
          <TableColumnResizer
            width={columnWidths.output_send_date}
            // height={30} // Header height
            onResize={handleColumnResize('output_send_date')}
          />
        </>,
        selector: (row) => row?.delivery_date,
        cell: (row) =>
          (row.delivery_date ? row.delivery_date : ''),
        width: `${columnWidths.output_send_date}px`,
        sortable: true,
      },
      {
        id: 'output_generated_time',
        name: <>
          File Delivered Date
          <TableColumnResizer
            width={columnWidths.output_generated_time}
            // height={30} // Header height
            onResize={handleColumnResize('output_generated_time')}
          />
        </>,
        selector: (row) => row?.output_generated_time,
        cell: (row) => row.output_generated_time ? row.output_generated_time : '',

        width: `${columnWidths.output_generated_time}px`,
        sortable: true,
      },
      {
        id: 'action',
        name: <>
          Action
          {/* <TableColumnResizer
            width={columnWidths.action}
            // height={30} // Header height
            onResize={handleColumnResize('action')}
          /> */}
        </>,
        cell: (row) => <div className='d-flex flex-row align-items-center gap-2' onClick={() => handleRowClick(row)}>
          {row.generated_output_file_name && row.generated_output_file_name !== "" ?
            <Tooltip title="Output File" placement='top' disableInteractive>
              <div onClick={() => downloadSnippetImageFile(row, 'file_path')}>
                <HiOutlineDocumentText size={22} style={{ color: color.uiprimary }} />
              </div>
            </Tooltip>
            :
            <Tooltip disableInteractive title="" placement='top'>
              <div style={{ visibility: 'hidden' }}>
                <HiOutlineDocumentText size={22} style={{ color: color.uiprimary }} />
              </div>
            </Tooltip>
          }

        </div>,


        // width: `${columnWidths.action}px`,
      },
    ],
    [searchedKeys, pageno, limit, searchedStatus, exceptionLoader,columnWidths]
  );
  const { board, setBoard, handleClickResetsortableHeading, computedColumns,dragCardInitData,removeMultipleCards } = useSortableBoard(columns);
  const onPageChange = (newPage) => {
    setPageno(newPage);
    setUpdate(!update);
  };
  const onPerPageChange = (newPerPage) => {
    setLimit(newPerPage);
    setPageno(1);
    setUpdate(!update);
  };
  const handleRowClick = (row, name = null) => {
    setColorRow(row);
    if ((name?.target?.getAttribute("data-column-id") == "exception_files" || name == "exception_files") && row?.exception_files > 0) {
      setExceptionLoader(row?.select_id);
      getExceptionReprtData({ lockbox_id: row?.lockbox_id,file_wise_listing:searchedKeys?.is_file_level==1,file_name:row?.lockbox_file_name })((response) => {
        if (response.data?.status_code === 200) {
          setExceptionLoader(null);
          setReportData(response?.data?.data);
          setToggleReportPopup(true);
        } else {
          createNotification("error", _static_messages.DEFAULT);
          setExceptionLoader(null);
        }
      });
    }
  };

  const handleSort = (column, order) => {
    console.log(column, order);
    setSearchedKeys({
      ...searchedKeys,
      sort_key: column?.id,
      sort_order: order,
    });
    setSearch({
      ...searchedKeys,
      sort_key: column?.id,
      sort_order: order,
    });
    setUpdate(!update);
  }; 
  const conditionalRowStyles = [
    {
      when: (row) => (colorRow.select_id == row.select_id ? true : false),
      style: (row, index) => ({
        backgroundColor: colorRow?.select_id == row.select_id ? "#dbf4f5" : "#f2f2f2",
        color: "black",
      }),
    },
  ];
  const queueDatatableCustomStyles = {
    rows: {
      style: {
        minHeight: "30px",
        fontSize: "0.9em",
        fontColor: "#000000",
      },
    },
    headCells: {
      style: {
        paddingLeft: "10px",
        paddingRight:"0px",
        fontWeight: "800",
      },
    },
    headRow: {
      style: {
        minHeight: "30px",
      },
    },
    cells: {
      style: {
        borderRight: "1px solid #dcdcdc",
        paddingLeft: "10px",
        paddingRight: "5px",
      },
    },
  };

  //////////////////////////////////////datatable function end ////////////////////////////////

  const navigateToHtmlView = (row) => {
    if (searchParams.get("rem")) {
      dispatch(setSearchDetails2({ name: "REMITTANCES", key: searchedKeys, page: pageno, limit: limit, status: searchedStatus }));
    } else {
      dispatch(setSearchDetails({ name: "REMITTANCES", key: searchedKeys, page: pageno, limit: limit, status: searchedStatus }));
    }
    navigate({
      pathname: PAYMENT_HTML_VIEW,
      search: `?${createSearchParams({
        pmt: row.lockbox_id,
      })}`,
    });
  };

  /////////////////////////////////Date functions start //////////////////////////////////

  const formRef = React.useRef(null);
  const dateRef = React.useRef(null);

   const handleDateChange = (ist = null,date, type,action=null) => {
        if(action==='onchange'){

            if (date !== 'null' && date !== null) {
                setSearch({ ...search, [type]: ist })
            }
            if (ist && ist?.length) {
                if (ist?.length == 1) {
                    setSearch({ ...search, [type]: [ist[0]] })
                }
                else {
                    setSearch({ ...search, [type]: [ist[0], ist[1]] })
    
                }
            }
        }else if(action==='onclose'){
            if (ist?.length == 1) {
                setSearch({ ...search, [type]: [search[type][0], search[type][0]] })
    
            }
        }
    };
  const handleClearDate = (type) => {
    setSearch({ ...search, [type]: null, errorField: { ...search?.errorField, [type]: false } });
  };
  ////////////////////////////////////Date functions end /////////////////////////////////

  const handleSearchChange = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };
  const onSearchClick = (e) => {
    e.preventDefault();
    if (!search?.errorField?.submission_date && !search?.errorField?.created_date) {
      setSearchedKeys(search);
      setSearchedStatus(status);
      setPageno(1);
      setUpdate(!update);
      updateHeaderBoard(search?.is_file_level||0)
    }
  };
  const handleSelectChange = (selected) => {
    setStatus(selected ?? null);
  };



  const onClearSearch = (e) => {
    e.preventDefault();
    setSearch({
      date: null,
      is_exclude: false,
         is_file_level: 0,
      client_name: clientDropdownData,
       facility_name: facilityDropdowndata,
      lockbox_no: "",
      lockbox_file_name: "",
      sort_order: "",
      sort_key: "",
      errorField: {},
      file_name: "",
    });
    setSearchedKeys({
      date: null,
      is_exclude: false,
         is_file_level: 0,
      client_name: clientDropdownData,
       facility_name: facilityDropdowndata,
      lockbox_no: "",
      lockbox_file_name: "",
      sort_order: "",
      sort_key: "",
      errorField: {},
      file_name: "",

    });
    setStatus(null);
    setSearchedStatus(null);
    setPageno(1);
    setUpdate(!update);
    updateHeaderBoard(0)
  };
  const handleClearSearchData = (type) => {
    setSearch({ ...search, [type]: "" });
  };
  const submitReason = () => {
    if (popup?.reason == "" || popup?.reason == undefined) {
      setPopup({ ...popup, error: true });
      return;
    }
    if (popup?.type == "EXPORT") {
      exportFile({ url: "payment/get-payments?is_file=1&", model_number: 4, type: "csv", master: searchParams.get("rem"), search: searchedKeys, matched: searchedStatus?.value, setLoading: setLoading, reason: popup?.reason });
    }
    setPopup({
      view: false,
      reason: "",
      data: "",
      type: "",
    });
  };
  const updateHeaderBoard = (is_file_level)=>{
    let items = board.columns[0].cards;
    if(is_file_level == 1){
      items = items?.map(item1=>item1?.id==='lockbox_file_name'?{...item1,label:"File Name"}:item1)?.filter(item=>item?.id!="no_of_files")
    }else{
      const currentIndex = columns?.findIndex(item=>item?.id==='no_of_files')
      const currentDict = columns?.find(item=>item?.id==='no_of_files')
      items = items?.map(item1=>item1?.id==='lockbox_file_name'?{...item1,label:"Lockbox File Name"}:item1)
      if(!(items?.some(i=>i.id==='no_of_files'))){
        items?.splice(currentIndex,0,{
          id: currentDict.id,
          label: currentDict.name,
          checked: true,
        })
      }
    }
console.log(items,"agggg11111111111");
    setBoard({
      columns: [
          {
              id: 1,
              cards: [
                  ...items
              ],
          },
      ],
    })
  }
  useEffect(()=>{
    if(!searchedKeys?.is_file_level){
     removeMultipleCards(["lockbox_file_name_1"]) 
    }

  },[searchedKeys?.is_file_level])

    const getExport = async (props) => {
        return new Promise((resolve, reject) => {
            const excludedNames = ["action"];
            const reNameobj = {
             lockbox_file_name  :searchedKeys?.is_file_level==1?"file_name":"lockbox_file_name"
            }
            const headers = computedColumns
                .map(col => col.id.trim())
                .filter(name => !excludedNames.includes(name.toLowerCase()))
                .map(name => {
                    const key = reNameobj?.[name.toLowerCase()] ??  name.toLowerCase();
                    return key
                })

            getNonRevarcData({
                query: { page: pageno, pageSize: limit },
                search: searchedKeys,
                export: true,
                comment: props?.comment,
                headers
            })(response => {
                if (response?.data?.status) {
                    console.log("AAAA", response);
                    window.open(Proxy(response?.data?.data), "_blank");
                    resolve(); // Important: resolve when done
                } else {
                    reject();  // Optional: reject on failure
                }
            })
        });
    };

  return (
    <div className="container-fluid">
      <div className="custom-card-ui">
        <div className="row">
          <div className="col-12" style={{ zIndex: "1" }}>
            <Card>
              <Card.Header>
                <Form onSubmit={onSearchClick} ref={formRef} id="searchForm" onReset={onClearSearch}>
                  <div className="d-flex flex-row justify-content-end align-items-end flex-wrap">
                   
                  <Clientdropdown  search={search} setSearch={setSearch} />
                  <Facilitydropdown  client={search?.client_name} search={search} setSearch={setSearch} />
                    {!!(search?.is_file_level) && <TextField 
                      style={{ width: "130px" }}
                      InputProps={{
                        endAdornment: (
                          <IconButton onClick={() => handleClearSearchData("lockbox_file_name")}>
                            <AiOutlineClose size={"0.6em"} />
                          </IconButton>
                        ),
                      }}
                      id="standard-basic"
                      name="lockbox_file_name"
                      value={search?.lockbox_file_name}
                      onChange={(e) => handleSearchChange(e)}
                      label="Lockbox File Name"
                      className="me-2 "
                      variant="standard"
                    />}
                 
                  <TextField
                      style={{ width: "130px" }}
                      InputProps={{
                        endAdornment: (
                          <IconButton onClick={() => handleClearSearchData("file_name")}>
                            <AiOutlineClose size={"0.6em"} />
                          </IconButton>
                        ),
                      }}
                      id="standard-basic"
                      name="file_name"
                      value={search?.file_name}
                      onChange={(e) => handleSearchChange(e)}
                      label="File Name"
                      className="me-2 "
                      variant="standard"
                    />
                   <TextField
                      style={{ width: "130px" }}
                      InputProps={{
                        endAdornment: (
                          <IconButton onClick={() => handleClearSearchData("lockbox_no")}>
                            <AiOutlineClose size={"0.6em"} />
                          </IconButton>
                        ),
                      }}
                      id="standard-basic"
                      name="lockbox_no"
                      value={search?.lockbox_no}
                      onChange={(e) => handleSearchChange(e)}
                      label="Lockbox No"
                      className="me-2 "
                      variant="standard"
                    />
                  

                    <Tooltip disableInteractive title="Deposit Date" placement="top">
                      <div className="input-group input-group-sm global-input-group me-2">
                        <Flatpickr
                          ref={flatpickrUploadRef}
                          className="form-control dash-filter-picker flatpickr-input active global-date-input"
                          value={search?.date}
                          // defaultValue={Date()}
                          placeholder="Deposit Date"
                          onClose={(ist, date) => handleDateChange(ist, date, 'date', 'onclose')}
                          onChange={(ist, date) => handleDateChange(ist, date, 'date', 'onchange')}
                          options={{
                            dateFormat: "m/d/Y",
                            mode: "range",
                            altInputClass: "hide",
                            disable: [
                              function (date) {
                                if (date.getDay() === 0) {
                                  // return true
                                  // return !(date.getDay() % 7);
                                }
                              },
                            ],
                          }}
                        />
                        <div
                          className="input-group-text global-input-text"
                          onClick={() => {
                            flatpickrUploadRef.current.flatpickr.toggle();
                          }}
                        >
                          <i className="ri-calendar-2-line"></i>
                        </div>
                        <button onClick={(e) => handleClearDate("date")} class="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeMedium css-78trlr-MuiButtonBase-root-MuiIconButton-root" tabindex="0" type="button">
                          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="0.6em" width="0.6em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
                          </svg>
                          <span class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
                        </button>
                      </div>
                    </Tooltip>
                    <Tooltip disableInteractive title="File Delivered Date" placement="top" className='ms-2'>
                      <div className="input-group input-group-sm global-input-group me-2">
                        <Flatpickr
                          ref={filesubmiteRef}
                          className="form-control dash-filter-picker flatpickr-input active global-date-input"
                          value={search?.file_submitted_date}
                          // defaultValue={Date()}
                          placeholder='File Delivered Date'
                          onClose={(ist, date) => handleDateChange(ist, date, 'file_submitted_date', 'onclose')}
                          onChange={(ist, date) => handleDateChange(ist, date, 'file_submitted_date', 'onchange')}

                          options={{
                            dateFormat: "m/d/Y",
                            mode: 'range',
                            altInputClass: 'hide',
                            disable: [
                              function (date) {
                                if (date.getDay() === 0) {
                                  // return true
                                  // return !(date.getDay() % 7);
                                }
                              }
                            ]
                          }}

                        />
                        <div className="input-group-text global-input-text" 
                         onClick={() => {
                            filesubmiteRef.current.flatpickr.toggle();
                          }}>
                          <i className="ri-calendar-2-line"></i>
                        </div>
                        <button onClick={(e) => handleClearDate('file_submitted_date')} class="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeMedium css-78trlr-MuiButtonBase-root-MuiIconButton-root" tabindex="0" type="button"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="0.6em" width="0.6em" xmlns="http://www.w3.org/2000/svg"><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg><span class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span></button>
                      </div>
                    </Tooltip> 


                    <Tooltip disableInteractive title="Exclude Completed" placement="top">
                      <div className="custome-toggle-switch-btn ms-2 me-2">
                        <label class="switch">
                          <input
                            checked={search.is_exclude}
                            onChange={(e) => {
                              setSearch({
                                ...search,
                                is_exclude: e.target.checked,
                              });
                            }}
                            type="checkbox"
                          />
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </Tooltip>
                    <Tooltip disableInteractive title="File Level Listing" placement="top">
                      <div className="custome-toggle-switch-btn ms-2 me-2">
                        <label class="switch">
                          <input
                            checked={search.is_file_level==1?true:false}
                            onChange={(e) => {
                              reactLocalStorage.set("is_file_level", e.target.checked?1:0);
                              setSearch({
                                ...search,
                                is_file_level: e.target.checked?1:0,
                                ...(!(e.target.checked)?{lockbox_file_name:""}:{}) 
                              });
                            }}
                            type="checkbox"
                          />
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </Tooltip>
                    <div className="d-flex flex-row align-items-center mt-2">
                      <Button size="medium" className=" me-2 mt-2" variant="outlined" style={{ color: "#1ba1a6", borderColor: "#1ba1a6" }} type="submit" startIcon={<Search />}>
                        Search
                      </Button>
                      <Button size="medium" className="mt-2" variant="outlined" style={{ color: "#1ba1a6", borderColor: "#1ba1a6" }} type="reset" startIcon={<Clear />}>
                        Clear
                      </Button>
                      <DragToSortDropdown
                                                board = {board}
                                                setBoard={setBoard} 
                                                headerType="file_monitoring"
                                                handleClickResetsortableHeading={handleClickResetsortableHeading}
                                                dragCardInitData={dragCardInitData}
                                                />
                    </div>
                    <div className="d-flex flex-row align-items-center justify-content-end gap-2  me-2 mb-1 ms-2 mt-2">
                      <Tooltip title="Refresh Data" placement="top" disableInteractive>
                        <div onClick={() => setUpdate(!update)} role="button">
                          <Refresh size={22} style={{ color: "#1ba1a6" }} />
                        </div>
                      </Tooltip>
                     <ExportWithReason
                        exportFile={getExport}
                        data={data?.data?.results.length}
                    />
                    </div>
                  </div>
                </Form>
              </Card.Header>
              <Card.Body>
                {datatable ? (
                  <DataTable
                    data={data?.data?.results}
                    className="custom-datatable"
                    columns={computedColumns}
                    progressPending={loading}
                    pagination
                    paginationDefaultPage={pageno}
                    paginationServer
                    highlightOnHover={true}
                    pointerOnHover={true}
                    paginationRowsPerPageOptions={[25, 50, 100]}
                    fixedHeader={true}
                    paginationTotalRows={totalRows}
                    paginationPerPage={limit}
                    onChangeRowsPerPage={onPerPageChange}
                    onChangePage={onPageChange}
                    theme="solarized"
                    customStyles={queueDatatableCustomStyles}
                    conditionalRowStyles={conditionalRowStyles}
                    striped={true}
                    onRowClicked={handleRowClick}
                    responsive={true}
                    sortServer
                    onSort={handleSort}
                  />
                ) : (
                  <></>
                )}
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
      <Modal show={popup?.view} size="lg" onHide={() => setPopup(false)}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="detail-modal">
            <div>
              <label className="form-label">Reason</label>
              <textarea type="text" maxLength={500} rows={5} className="form-control" name="user_name" placeholder="Enter Reason" onChange={(e) => setPopup({ ...popup, reason: e.target.value })} value={popup?.reason} />
              {popup?.error ? <div className="text-danger p-2">This field is required</div> : <></>}

              <div className="hstack gap-2 justify-content-end mt-2">
                <ReactiveButton
                  style={{ backgroundColor: "#b7babf" }}
                  idleText="Cancel"
                  onClick={() =>
                    setPopup({
                      view: false,
                      reason: "",
                      data: "",
                      type: "",
                    })
                  }
                />

                <ReactiveButton
                  style={{ backgroundColor: "#1ba1a6" }}
                  className="mr-2"
                  type={"button"}
                  buttonState={loading?.loading ? loading?.type : "idle"}
                  idleText="Submit"
                  loadingText="Loading"
                  successText="Done"
                  disabled={false}
                  onClick={submitReason}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ExceptionReportModal toggleReportPopup={toggleReportPopup} setToggleReportPopup={setToggleReportPopup} reportData={reportData} setReportData={setReportData} />
    </div>
  );
};

export default NonRevarcDashboard;
